import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationItemSimpleActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Item/ItemSimple")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationItem"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationItem"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationItemSimpleActivity)
